type CsvValue = string | number | boolean | null | undefined;

type CsvColumn<T> = {
  key: string;
  label: string;
  resolve: (row: T) => CsvValue;
};

function escapeCsvValue(value: CsvValue) {
  const normalized = value == null ? '' : String(value);
  const escaped = normalized.replace(/"/g, '""');

  if (/[",\n]/.test(escaped)) {
    return `"${escaped}"`;
  }

  return escaped;
}

export function exportCsv<T>(fileName: string, columns: CsvColumn<T>[], rows: T[]) {
  const header = columns.map((column) => escapeCsvValue(column.label)).join(',');
  const lines = rows.map((row) => columns.map((column) => escapeCsvValue(column.resolve(row))).join(','));
  const csv = [header, ...lines].join('\n');
  const blob = new Blob([csv], { type: 'text/csv;charset=utf-8;' });
  const url = URL.createObjectURL(blob);
  const link = document.createElement('a');

  link.href = url;
  link.download = fileName;
  link.click();

  URL.revokeObjectURL(url);
}